__turbopack_context__.v({
  "carouselFooter": "_00-ZBG_carouselFooter",
  "carouselImageArea": "_00-ZBG_carouselImageArea",
  "realImagesPill": "_00-ZBG_realImagesPill",
  "root": "_00-ZBG_root",
});
